const csgoCategories = [
    {
        key: 'knife',
        icon: '',
        name: 'Knife',
        items: [
            { key: 'karambit', name: 'Karambit' },
            { key: 'm9-bayonet', name: 'M9 Bayonet' },
            { key: 'bayonet', name: 'Bayonet' },
            { key: 'butterfly-knife', name: 'Butterfly Knife' },
            { key: 'flip-knife', name: 'Flip Knife' },
            { key: 'gut-knife', name: 'Gut Knife' },
            { key: 'huntsman-knife', name: 'Huntsman Knife' },
            { key: 'shadow-daggers', name: 'Shadow Daggers' },
            { key: 'falchion-knife', name: 'Falchion Knife' },
            { key: 'bowie-knife', name: 'Bowie Knife' },
            { key: 'paracord-knife', name: 'Paracord Knife' },
            { key: 'survival-knife', name: 'Survival Knife' },
            { key: 'ursus-knife', name: 'Ursus Knife' },
            { key: 'navaja-knife', name: 'Navaja Knife' },
            { key: 'stiletto-knife', name: 'Stiletto Knife' },
            { key: 'talon-knife', name: 'Talon Knife' },
            { key: 'classic-knife', name: 'Classic Knife' },
        ],
    },

    {
        key: 'gloves',
        icon: '',
        name: 'Gloves',
        items: [
            { key: 'specialist-gloves', name: 'Specialist Gloves' },
            { key: 'sport-gloves', name: 'Sport Gloves' },
            { key: 'hand-wraps', name: 'Hand Wraps' },
            { key: 'driver-gloves', name: 'Driver Gloves' },
            { key: 'moto-gloves', name: 'Moto Gloves' },
            { key: 'bloodhound-gloves', name: 'Bloodhound Gloves' },
            { key: 'hydra-gloves', name: 'Hydra Gloves' },
        ],
    },

    {
        key: 'rifle',
        icon: '',
        name: 'Rifle',
        items: [
            { key: 'ak-47', name: 'AK-47' },
            { key: 'm4a4', name: 'M4A4' },
            { key: 'm4a1-s', name: 'M4A1-S' },
            { key: 'aug', name: 'AUG' },
            { key: 'sg-553', name: 'SG 553' },
            { key: 'famas', name: 'FAMAS' },
            { key: 'galil-ar', name: 'Galil AR' },
        ],
    },

    {
        key: 'sniper-rifle',
        icon: '',
        name: 'Sniper Rifle',
        items: [
            { key: 'awp', name: 'AWP' },
            { key: 'ssg-08', name: 'SSG 08' },
        ],
    },
    {
        key: 'pistol',
        icon: '',
        name: 'Pistol',
        items: [
            { key: 'glock-18', name: 'Glock-18' },
            { key: 'usp-s', name: 'USP-S' },
            { key: 'p2000', name: 'P2000' },
            { key: 'dual-berettas', name: 'Dual Berettas' },
            { key: 'p250', name: 'P250' },
            { key: 'five-seven', name: 'Five-SeveN' },
            { key: 'tec-9', name: 'Tec-9' },
            { key: 'cz75-auto', name: 'CZ75-Auto' },
            { key: 'desert-eagle', name: 'Desert Eagle' },
            { key: 'r8-revolver', name: 'R8 Revolver' },
        ],
    },

    {
        key: 'smg',
        icon: '',
        name: 'SMG',
        items: [
            { key: 'mp9', name: 'MP9' },
            { key: 'mac-10', name: 'MAC-10' },
            { key: 'mp7', name: 'MP7' },
            { key: 'ump-45', name: 'UMP-45' },
            { key: 'p90', name: 'P90' },
            { key: 'pp-bizon', name: 'PP-Bizon' },
            { key: 'mp5-sd', name: 'MP5-SD' },
        ],
    },

    {
        key: 'shotgun',
        icon: '',
        name: 'Shotgun',
        items: [
            { key: 'nova', name: 'Nova' },
            { key: 'xm1014', name: 'XM1014' },
            { key: 'mag-7', name: 'MAG-7' },
            { key: 'sawed-off', name: 'Sawed-Off' },
        ],
    },

    {
        key: 'machine-gun',
        icon: '',
        name: 'Machine Gun',
        items: [
            { key: 'm249', name: 'M249' },
            { key: 'negev', name: 'Negev' },
        ],
    },

    {
        key: 'agent',
        icon: '',
        name: 'Agents',
        items: [
            { key: 't', name: 'T' },
            { key: 'ct', name: 'CT' },
        ],
    },

    {
        key: 'sticker',
        icon: '',
        name: 'Sticker',
        items: [
            { key: 'spray', name: 'Spray' },
            { key: 'collectibles', name: 'Collectibles' },
            { key: 'patches', name: 'Patches' },
            { key: 'tools', name: 'Tools' },
            { key: 'music-kits', name: 'Music Kits' },
        ],
    },

    {
        key: 'other',
        icon: '',
        name: 'Other',
        items: [
            { key: 'spray', name: 'Spray' },
            { key: 'collectibles', name: 'Collectibles' },
            { key: 'patches', name: 'Patches' },
            { key: 'tools', name: 'Tools' },
            { key: 'music-kits', name: 'Music Kits' },
        ],
    },
]

export default csgoCategories
